module.exports = __webpack_public_path__ + "static/img/4-1.8b4a5c80.png";